import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

export default class TypesFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <select
                className="filter-input"
                onChange={(event) => this.props.onChange(event.target.value)}
                value={_.get(this.props, 'filter.value', '')}
            >
                <option value="">ALL</option>
                <option value="0">0: CANCELED</option>
                <option value="1">1: INITIAL</option>
                <option value="2">2: WON</option>
                <option value="3">3: REPRESENT</option>
                <option value="3.1">3.1: REPRESENT (OPEN)</option>
                <option value="3.2">3.2: REPRESENT (CLOSED)</option>
                <option value="4">4: FINAL</option>
                <option value="4.1">4.1: FINAL (CLOSED)</option>
            </select>
        );
    }
}
